import MiBackBtn from '@/packages/@mi-components/MiBackBtn/MiBackBtn.vue'

export default MiBackBtn
